import { render, staticRenderFns } from "./report-msg.vue?vue&type=template&id=58f9a911"
import script from "./report-msg.vue?vue&type=script&lang=js"
export * from "./report-msg.vue?vue&type=script&lang=js"
import style0 from "./report-msg.vue?vue&type=style&index=0&id=58f9a911&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports